import { render, staticRenderFns } from "./MatrixByCostCenterReportTable.vue?vue&type=template&id=066dc310"
import script from "./MatrixByCostCenterReportTable.vue?vue&type=script&lang=js"
export * from "./MatrixByCostCenterReportTable.vue?vue&type=script&lang=js"
import style0 from "./MatrixByCostCenterReportTable.vue?vue&type=style&index=0&id=066dc310&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports